import type {DelayAction} from 'src/action-creators/delay';

import {
  UPADTE_DELAY_NODE_SCHEDULING,
  RECEIVE_DELAY_NODE_SCHEDULING,
} from 'src/action-creators/delay';


export type DelayNodeState = {
  days: number;
  hours: number;
  minutes: number;
};

const initialState = {
  days: 0,
  hours: 0,
  minutes: 0,
} as const;

export default (
  state: DelayNodeState = initialState,
  action: DelayAction,
): DelayNodeState => {
  switch (action.type) {
    case UPADTE_DELAY_NODE_SCHEDULING:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_DELAY_NODE_SCHEDULING:
      return {
        ...state,
        ...action.payload,
      };
  }
  return state;
};
